import React, { useEffect } from 'react'

import './styles.scss'
import { TPaginationProps } from '../../types/Pagination.types'

const Pagination = ({
  currentPage,
  goToPage,
  pages,
}: TPaginationProps): JSX.Element => {
  const emptyButtonLabel = '...'
  const firstPage = 1
  const pagesArr = new Array(pages).fill(null).map((_, i: number) => ++i)

  useEffect(() => {
    currentPage = firstPage
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  const handlePageClick = (page: number) => {
    if (page === currentPage) {
      return
    }
    goToPage(page)
    window?.location?.reload()
  }
  const handlePrevClick = () => {
    if (currentPage - 1 < firstPage) {
      return
    }
    goToPage(currentPage - 1)
    window?.location?.reload()
  }
  const handleNextClick = () => {
    if (currentPage + 1 > pages) {
      return
    }
    goToPage(currentPage + 1)
    window?.location?.reload()
  }
  const filterInRangePage = (pageToCheck: number): boolean => {
    const adjacentPageToShow = 2
    if (pageToCheck === firstPage || pageToCheck === pages) return true

    if (currentPage === pageToCheck) return true

    if (
      currentPage < pageToCheck &&
      currentPage + adjacentPageToShow >= pageToCheck
    )
      return true

    if (
      currentPage > pageToCheck &&
      currentPage - adjacentPageToShow <= pageToCheck
    )
      return true

    return false
  }
  const addEmptyButton = (
    acc: (number | string)[],
    curr: number
  ): (number | string)[] => {
    if (curr === firstPage) {
      return [...acc, curr]
    }

    const lastEl = acc[acc.length - 1]
    if (lastEl === firstPage && curr - 1 > firstPage) {
      acc.push(emptyButtonLabel)
    }
    if (curr === pages && lastEl !== pages - 1) {
      acc.push(emptyButtonLabel)
    }
    return [...acc, curr]
  }

  return (
    <section className="pagination">
      <div className="pagination__container">
        <button
          className="pagination__button_previcon"
          type="button"
          onClick={() => handlePrevClick()}
        >
          <pfe-icon icon="cnh-arrow-backward" size="24" className="PFElement" />
        </button>
        {pagesArr
          .filter(filterInRangePage)
          .reduce(addEmptyButton, [])
          .map((page: number | string, i: number) =>
            typeof page === 'string' ? (
              <pfe-cta
                pfe-priority="primary"
                class="pagination__button pagination__button--disabled"
                key={`page-${i}`}
                disabled
              >
                <button>{page}</button>
              </pfe-cta>
            ) : (
              <pfe-cta
                pfe-priority="primary"
                class={
                  'pagination__button' +
                  (page === currentPage ? ' pagination__button--active' : '')
                }
                key={`page-${i}`}
                onClick={() => handlePageClick(page)}
              >
                <button>{page}</button>
              </pfe-cta>
            )
          )}
        <button
          className={`pagination__button_previcon ${
            currentPage === pages ? 'disabled' : ''
          }`}
          type="button"
          onClick={() => handleNextClick()}
        >
          <pfe-icon icon="cnh-arrow-forward" size="24" />
        </button>
      </div>
    </section>
  )
}

export default Pagination
